import script from "./AllDocumentsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllDocumentsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AllDocumentsPage.vue?vue&type=style&index=0&id=61204472&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61204472"]])

export default __exports__